import React, { useState, useEffect } from 'react';
import { useSession } from '@/context/SessionContext';
import LearnerLayout from '@/components/LearnerLayout';
import { Loader2, User } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LearnerApprenantsPage = () => {
  const { selectedSessionId, currentCourse } = useSession();
  const [apprenants, setApprenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedSessionId) { setLoading(false); return; }
    fetch(`${API}/learner/dashboard/${selectedSessionId}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.co_apprenants) setApprenants(d.co_apprenants); else if (d?.apprenants) setApprenants(d.apprenants); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [selectedSessionId]);

  const courseTitle = currentCourse?.title || 'Formation';

  return (
    <LearnerLayout>
      <div data-testid="learner-apprenants-page">
        <p className="text-sm text-slate-400 mb-6">{courseTitle} - Apprenants</p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8" data-testid="apprenants-title">Apprenants</h1>

        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>
        ) : (
          <div className="flex flex-wrap gap-6" data-testid="apprenants-grid">
            {apprenants.map((a, i) => {
              const parts = (a.name || '').split(' ');
              const lastName = parts.length > 1 ? parts[0].toUpperCase() : (a.name || '').toUpperCase();
              const firstName = parts.length > 1 ? parts.slice(1).join(' ') : '';
              return (
                <div key={i} className="flex flex-col items-center w-36" data-testid={`apprenant-card-${i}`}>
                  <div className="w-36 h-44 rounded-2xl bg-blue-600 flex items-center justify-center overflow-hidden border-2 border-blue-500 shadow-md mb-3">
                    {a.photo_url ? (
                      <img src={a.photo_url} alt={a.name} className="w-full h-full object-cover" />
                    ) : (
                      <User className="h-16 w-16 text-white/70" strokeWidth={1.2} />
                    )}
                  </div>
                  <p className="text-sm font-bold text-slate-900 text-center leading-snug">{lastName} {firstName}</p>
                </div>
              );
            })}
            {apprenants.length === 0 && (
              <p className="text-slate-500 italic" data-testid="no-apprenants">Aucun apprenant inscrit à cette session.</p>
            )}
          </div>
        )}
      </div>
    </LearnerLayout>
  );
};

export default LearnerApprenantsPage;
